import { motion } from "framer-motion";
import { ACHIEVEMENTS } from "@/lib/content";
import { fadeUp, stagger } from "@/lib/motion";
import { Award } from "lucide-react";

export default function Achievements() {
  return (
    <section
      id="achievements"
      data-testid="achievements-section"
      className="relative bg-ink-950 py-28 md:py-40 border-t border-ivory/[0.06]"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={stagger}
          className="grid grid-cols-12 gap-6 md:gap-12"
        >
          <motion.div variants={fadeUp} className="col-span-12 md:col-span-5">
            <div className="font-mono-caps text-[10px] text-copper mb-6">
              <span className="mr-3">§ 05</span> Recognition
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-ivory">
              Awards<br />
              <span className="italic text-copper">& Memberships.</span>
            </h2>
            <p className="mt-8 text-ivory/60 max-w-md leading-relaxed">
              Recognitions across international real estate, luxury advisory and professional bodies —
              markers, not milestones.
            </p>
          </motion.div>

          <motion.div variants={fadeUp} className="col-span-12 md:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
              {ACHIEVEMENTS.map((a, i) => (
                <motion.div
                  key={i}
                  variants={fadeUp}
                  className="group relative border border-ivory/[0.08] hover:border-copper/60 p-6 md:p-8 bg-ink-900/40 transition-colors duration-500"
                  data-testid={`achievement-${i}`}
                >
                  <div className="flex items-center justify-between mb-6">
                    <Award size={18} className="text-copper" />
                    <span className="font-mono text-[10px] text-ivory/40">{a.year}</span>
                  </div>
                  <h3 className="font-serif text-xl md:text-2xl text-ivory leading-tight">
                    {a.title}
                  </h3>
                  <p className="mt-3 font-mono-caps text-[9px] text-ivory/50">{a.org}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
